/**
 * 描述： 在线模板编辑
 * 录入人： 张磊
 */
import request from '../request.js'


/**
 * 描述： 列表（ 分页） 查询接口
 * 接口管理员： 叶凡
 * 参数：{}
 */
export const getPageList = function (data) {
    return request({
        url: 'templateRecord/getPageList',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: false
        },
    })
}

/**
 * 描述： 编辑保存接口
 * 接口管理员： 叶凡
 * 参数：{}
 */
export const saveTemplate = function (data) {
    return request({
        url: 'templateRecord/saveTemplate',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: false
        },
    })
}

/**
 * 描述： 编辑时加载模板信息接口
 * 接口管理员： 叶凡
 * 参数：{}
 */
export const getTemplateInfo = function (data) {
    return request({
        url: 'templateRecord/getTemplateInfo',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: false
        },
    })
}

/**
 * 描述： 启用 / 禁用（ 删除） 接口
 * 接口管理员： 叶凡
 * 参数：{}
 */
export const updateTemplate = function (data) {
    return request({
        url: 'templateRecord/updateTemplate',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: false
        },
    })
}
